import { showBtnLoading, stopBtnLoading } from './loading'
import { showCommonMessage } from './popup'

export function toggleMeMode(btID, enable, cb) {

    let msg = enable ? `<h2>'Me' mode on</h2><br>Me mode is for testing and debugging. Regular visitors will continue to see the original webpages without any affect of RabbitLoader. Only you can access the RabbitLoader optimized pages by appending "?rltest=1" to  URLs.` : `<h2>'Everyone' mode on</h2><br>Use it if, you are ready to show the optimized pages to everyone. `;
    if (btID) {
        showBtnLoading(`#${btID}`, 'Enabling Me Mode...');
    }

    const formData = new FormData();
    formData.append('action', "rabbitloader_mode_change");
    formData.append('private_mode', enable ? 1 : 0);
    formData.append('rl_nonce', rabbitloader_local_vars.rl_nonce);

    fetch(ajaxurl, {
        'method': 'POST',
        'body': formData
    }).then(res => res.json())
        .then(json => {
            console.log(json);
            if (json && json.result) {
                showCommonMessage(msg);
                cb(true);
            } else {
                showCommonMessage('Settings could not be saved');
                cb(false);
            }
            if (btID) {
                stopBtnLoading(`#${btID}`);
            }
        });
}